export const formatCurrency = (amount) => {
  const value = Number(amount);
  if (Number.isNaN(value)) return "GH₵0.00";

  return new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(value)
    .replace("GHS", "GH₵");
};

export default formatCurrency;
